export const FACTURAS_OBTENER_LISTA = 'FACTURAS_OBTENER_LISTA';
export const FACTURAS_LISTA_LOADING = 'FACTURAS_LISTA_LOADING';

export const RECIBOS_OBTENER_LISTA = 'RECIBOS_OBTENER_LISTA';
export const RECIBOS_LISTA_LOADING = 'RECIBOS_LISTA_LOADING';
